/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AppSecretPasswordValidation
 */
export interface AppSecretPasswordValidation {
    /**
     * 
     * @type {string}
     * @memberof AppSecretPasswordValidation
     */
    password: string;
}

/**
 * Check if a given object implements the AppSecretPasswordValidation interface.
 */
export function instanceOfAppSecretPasswordValidation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "password" in value;

    return isInstance;
}

export function AppSecretPasswordValidationFromJSON(json: any): AppSecretPasswordValidation {
    return AppSecretPasswordValidationFromJSONTyped(json, false);
}

export function AppSecretPasswordValidationFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppSecretPasswordValidation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'password': json['password'],
    };
}

export function AppSecretPasswordValidationToJSON(value?: AppSecretPasswordValidation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'password': value.password,
    };
}

